module.exports = __webpack_public_path__ + "53dac03cf9ccf7ca761ae9ee7a95e876.pdf";